<template>
  <div class="partner-wrap container">
    <div class="partner-top flex flex_content_sb flex_items_center">
      <div class="partner-title" :class="{ entitle: langSet != 'cn' }">{{ title }}</div>
      <div
        class="btn-slide btn-slide-right small-btn flex_content_center flex_items_center" @click="toMore"
      >
        <div class="btn-main">{{ langSet == 'cn' ? '查看更多' : 'Details' }} <span class="icon"></span></div>
      </div>
    </div>
    <div class="partner-main">
      <template v-if="isShowPC">
        <vue-seamless-scroll
          v-if="firstHalf.length > 0"
          :data="firstHalf"
          :class-option="classOption"
          class="partner-list"
        >
          <ul>
            <li v-for="(item, index) in firstHalf" :key="index" @click="toLink(item.url)">
              <img class="image" :src="item.img" />
            </li>
          </ul>
        </vue-seamless-scroll>
        <vue-seamless-scroll
          v-if="secondHalf.length > 0"
          :data="secondHalf"
          :class-option="classOption"
          class="partner-list"
        >
          <ul>
            <li v-for="(item, index) in secondHalf" :key="index" @click="toLink(item.url)">
              <img class="image" :src="item.img" />
            </li>
          </ul>
        </vue-seamless-scroll>
      </template>
      <div v-else class="partner-list-wrap flex flex_wrap">
        <div
          class="image flex flex_content_center flex_items_center"
          v-for="(item, index) in partnerData"
          :key="index"
        >
          <img class="img" :src="item.img" @click="toLink(item.url)"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    partnerData: {
      type: Array,
      required: true,
    },
    targetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      langSet: "",
      isShowPC: false,
      classOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量
        direction: 2, // 0向下 1向上 2向左 3向右
        hoverStop: true, // 是否开启鼠标悬停stop
        openWatch: true, // 开启数据实时监控刷新dom
      },
    };
  },
  computed: {
    // 按索引分割（前半/后半）
    firstHalf() {
      const half = Math.ceil(this.partnerData.length / 2);
      return this.partnerData.length > 12
        ? this.partnerData.slice(0, half)
        : this.partnerData;
    },
    secondHalf() {
      const half = Math.ceil(this.partnerData.length / 2);
      return this.partnerData.length > 12 ? this.partnerData.slice(half) : [];
    },
  },
  mounted() {
    this.langSet = this.$language;
    this.isMobile();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    toMore() {
      this.$router.push({
        path: "/partner",
        query: {
          targetId: this.targetId
        }
      });
    },
    toLink(path){
      if(path){
        window.open(path, '_blank');
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.partner-wrap {
  background: #fafcff;
  border-radius: 30px;
  padding-bottom: 22px;
  margin-bottom: 50px;
  .partner-top {
    padding-right: 30px;
    .partner-title {
      width: 196px;
      height: 64px;
      line-height: 28px;
      font-weight: 500;
      font-size: 22px;
      color: #1d2379;
      padding-left: 50px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background: url("../../../assets/partner_title.jpg") no-repeat;
      background-size: 100% 100%;
    }
    .entitle{
      font-size: 14px;
      line-height: 18px;
      min-width: 210px;
    }
  }
  .partner-main {
    padding: 25px 30px 0;
    .partner-list {
      width: 100%;
      overflow: hidden;
      margin-bottom: 28px;
      ul {
        width: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // flex-wrap: nowrap;
        cursor: pointer;
        li {
          width: 183px;
          height: 80px;
          overflow: hidden;
          background: #fff;
          border: 1px solid rgba(6, 63, 151, 0.08);
          margin-right: 24px;
          float: left;
          display: flex;
          align-items: center;
          justify-content: center;
          .image {
            width: auto;
            height: auto;
            max-width: 90%;
            max-height: 90%;
          }
        }
      }
    }
    .partner-list-wrap {
      .image {
        width: 1.3rem;
        height: 0.77rem;
        overflow: hidden;
        background: #fff;
        border: 1px solid rgba(6, 63, 151, 0.08);
        margin-right: 0.2rem;
        margin-bottom: 0.19rem;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .img {
          width: auto;
          height: auto;
          max-width: 90%;
          max-height: 90%;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .partner-wrap {
    padding-bottom: 0.2rem;
    margin-bottom: 0.58rem;
    .partner-top {
      padding-right: 0.2rem;
      .partner-title {
        width: 3.38rem;
        height: 1.06rem;
        font-size: 0.35rem;
        line-height: 1.06rem;
        padding-left: 0.87rem;
      }
    }
    .partner-main {
      padding: 0.19rem 0.38rem 0;
      .partner-list {
        margin-bottom: 0.19rem;
        & > div {
          width: 100%;
        }
        ul li {
          width: 1.46rem;
          height: 0.77rem;
          margin-right: 0.29rem;
        }
      }
    }
  }
}
</style>